import fetchWrapper from './fetchWrapper';

// Helper function to decode HTML entities
const decodeHtmlEntities = (text) => {
  if (!text) return '';
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
};

const fetchServices = async () => {
  const response = await fetchWrapper('/api/servicesList');
  if (!response.ok) {
    throw new Error('Failed to fetch services');
  }
  const data = await response.json();
  
  // Decode HTML entities in notes
  const decodedData = data ? data.map(service => ({
    ...service,
    note: decodeHtmlEntities(service.note)
  })) : [];
  
  return decodedData;
};

const fetchServicesByCategory = async (category) => {
  const response = await fetchWrapper(`/api/servicesList/category/${category}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch services for category: ${category}`);
  }
  return response.json();
};

const fetchServiceById = async (id) => {
  const response = await fetchWrapper(`/api/servicesList/${id}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch service with id: ${id}`);
  }
  return response.json();
};

const createService = async (service) => {
  const token = localStorage.getItem('token');
  const response = await fetchWrapper('/api/servicesList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    },
    body: JSON.stringify(service)
  });
  if (!response.ok) {
    throw new Error('Failed to create service');
  }
  return response.json();
};

const updateService = async (id, service) => {
  const token = localStorage.getItem('token');
  const response = await fetchWrapper(`/api/servicesList/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    },
    body: JSON.stringify(service)
  });
  if (!response.ok) {
    throw new Error('Failed to update service');
  }
  return response.json();
};

const deleteService = async (id) => {
  const token = localStorage.getItem('token');
  const response = await fetchWrapper(`/api/servicesList/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    }
  });
  if (!response.ok) {
    throw new Error('Failed to delete service');
  }
  return response.json();
};

export {
  fetchServices,
  fetchServicesByCategory,
  fetchServiceById,
  createService,
  updateService,
  deleteService
};
